<template>
  <span style="word-break: break-word; max-width: 500px">
    <span v-if="IsJsonString() && checkAction()">
      <div class="d-flex flex-column justify-content-center">
        <div
          v-if="getUrl() != ''"
          class="d-flex justify-content-center my-2">
          <el-avatar
            :src="getUrl()"
            :size="100" />
        </div>
        <div
          class="mb-0 text-normal"
          style="white-space: pre-line">
          <div
            class="mb-0 text-normal"
            style="white-space: pre-line">
            <div v-if="isRtf" v-html="regexUrl(titleMessage)"></div>
            <div
              class="fw-semibold"
              v-else-if="getUrl() != '' || isHightLight" v-html="regexUrl(titleMessage)">
            </div>
            <div v-else>{{ JSON.parse(JSON.parse(this.content).params).msg.vi }}</div>
          </div>
        </div>
      </div>
    </span>
    <span
      v-else
      class="mb-0 text-normal"
      v-bind:class="messageRepied ? 'text-1-line-replied ' : ''"
      style="white-space: pre-line"
      v-bind:style="messageRepied ? 'word-break: break-word' : ''">
      <span
        id="regexText"
        @click="handleLinkClick"
        v-html="regexUrl(contentAfterHighlight)" />
    </span>
  </span>
</template>

<script>
import { removeVietnameseTones2 } from "../../lib/text-utils";

export default {
  props: ["content", "messageRepied", "mentions", "keyHighlight"],
  name: "ChatText",
  data() {
    return {
      listMentions: [],
    };
  },
  computed: {
    contentAfterHighlight() {
      if (!this.keyHighlight) return this.content;
      const normalizedText = removeVietnameseTones2(this.content.toLowerCase());
      const normalizedSearchKey = removeVietnameseTones2(this.keyHighlight.toLowerCase());

      const searchTerms = normalizedSearchKey.split(" ");

      let highlightedText = this.content;

      searchTerms.forEach((term) => {
        const regex = new RegExp(`(${term})`, "gi");
        normalizedText.replace(regex, (match) => {
          const start = normalizedText.indexOf(removeVietnameseTones2(match).toLowerCase());
          const originalMatch = this.content.substr(start, match.length);
          highlightedText = highlightedText.replace(
            new RegExp(`\\b${originalMatch}\\b`, "g"),
            `<span style="background-color: #DEB00C !important;">${originalMatch}</span>`
          );
          return match;
        });
      });
      
      return highlightedText;
    },
    titleMessage() {
      const contentMessage = JSON.parse(this.content);
      const message = contentMessage.title;
      // console.log(123, contentMessage);
      
      let result = "";
      let currentIndex = 0;
      const styles = JSON.parse(contentMessage.params).styles;
      
      let currentList = null;
      let currentListItems = [];
      let mergedStyles = [];

      styles.sort((a, b) => {
        if (a.start === b.start) return b.len - a.len;
        return a.start - b.start; 
      });

      styles.forEach(({ start, len, st }) => {
        const styleEnd = start + len;
        // const styleSet = new Set(st.split(",").map(s => s.trim()));
        const isList = st.includes("lst_1") || st.includes("lst_2");

        // tìm entry cùng start (nếu có)
        const sameStart = mergedStyles.find((m) => m.start === start);
        const existingIsList = sameStart && (sameStart.styles.has("lst_1") || sameStart.styles.has("lst_2"));

        if (sameStart && (isList || existingIsList)) {
          // luôn gộp các style vào entry cùng start (để các style áp dụng chung được giữ)
          st.split(",").map(s => s.trim()).forEach((s) => sameStart.styles.add(s));
          sameStart.len = Math.max(sameStart.len, len);

          // nếu entry cùng start là list và bản style hiện tại là một đoạn con (len < parent.len)
          // thì tạo child để giữ style cục bộ (ví dụ bold chỉ cho phần nhỏ)
          if (existingIsList && len < sameStart.len) {
            sameStart.children = sameStart.children || [];
            sameStart.children.push({
              start,
              len,
              styles: new Set(st.split(",").map(s => s.trim())),
            });
          }

          // nếu bản mới là list, đảm bảo children tồn tại
          if (isList) sameStart.children = sameStart.children || [];
          return;
        }

        // trường hợp bình thường: merge nếu nằm trong range của entry khác, ngược lại tạo entry mới
        let isMerged = false;
        mergedStyles.forEach((s) => {
          if (start >= s.start && styleEnd <= s.start + s.len) {
            st.split(",").map(x => x.trim()).forEach((x) => s.styles.add(x));
            isMerged = true;
          }
        });

        if (!isMerged) {
          mergedStyles.push({
            start,
            len,
            styles: new Set(st.split(",").map(s => s.trim())),
            children: isList ? [] : undefined,
          });
        }

        const parentList = mergedStyles
          .filter(
            (list) =>
              (list.styles.has("lst_1") || list.styles.has("lst_2")) &&
              start >= list.start &&
              !(list.start === start && list.len === len) &&
              styleEnd <= list.start + list.len
          )
          .sort((a, b) => b.start - a.start)[0];

        if (parentList) {
          parentList.children = parentList.children || [];
          parentList.children.push({
            start,
            len,
            styles: new Set(st.split(",").map(s => s.trim())),
          });
        }
      });

      mergedStyles.forEach(({ start, len, styles, children }) => {
        const text = message.substring(start, start + len);
        if (currentIndex < start) {
          const gapRaw = message.substring(currentIndex, start);
          const gapText = this.normalizeText(gapRaw, !!currentList);

          if (gapText.trim() !== "") {
            if (currentList) {
              // đóng list trước khi render text thường
              result += `${currentListItems.join("")}</${currentList}>`;
              currentList = null;
              currentListItems = [];
            }
            result += gapText;
          }
        }

        let styledText = text;
        let cssStyles = "";
        let listStyle = null;
        let indentation = "";

        styles.forEach((style) => {
          if (style === "b") cssStyles += "font-weight: bold; ";
          if (style === "i") cssStyles += "font-style: italic; ";
          if (style === "u") cssStyles += "text-decoration: underline; ";
          if (style === "s") cssStyles += "text-decoration: line-through; ";
          if (style.startsWith("f_")) cssStyles += `font-size: ${style.split("_")[1]}px; `;
          if (style.startsWith("c_")) cssStyles += `color: #${style.split("_")[1]}; `;
          if (style === "lst_1") {
            listStyle = "ul";
            cssStyles += "list-style-type: disc;";
          }
          if (style === "lst_2") {
            listStyle = "ol";
            cssStyles += "list-style-type: decimal;";
          }
          if (style.startsWith("ind_")) {
            indentation = `padding-left: ${style.split("_")[1]}px;`;
          }
        });

        if (cssStyles || indentation) {
          styledText = `<span style="${cssStyles} ${indentation}">${text}</span>`;
        }

        if (listStyle) {
          if (currentList !== listStyle) {
            if (currentList) {
              result += `${currentListItems.join("")}</${currentList}>`;
            }
            currentList = listStyle;
            currentListItems = [];
            result += `<${currentList} style="margin-left: 20px;">`;
          }

          let listItem = `<li>`;

          if (children && children.length > 0) {
            let prevEnd = start;
            children.forEach((child) => {
              const childStart = child.start;
              const childEnd = child.start + child.len;

              if (prevEnd < childStart) {
                listItem += message.substring(prevEnd, childStart).replace(/\n/g, "<br>");
              }

              const childText = message.substring(childStart, childEnd).replace(/\n/g, "<br>");
              let childCss = "";

              child.styles.forEach((style) => {
                if (style === "b") childCss += "font-weight: bold; ";
                if (style === "i") childCss += "font-style: italic; ";
                if (style === "u") childCss += "text-decoration: underline; ";
                if (style === "s") childCss += "text-decoration: line-through; ";
                if (style.startsWith("f_")) childCss += `font-size: ${style.split("_")[1]}px; `;
                if (style.startsWith("c_")) childCss += `color: #${style.split("_")[1]}; `;
              });

              listItem += `<span style="${childCss}">${childText}</span>`;
              prevEnd = childEnd;
            });

            if (prevEnd < start + len) {
              listItem += message.substring(prevEnd, start + len).replace(/\n/g, "<br>");
            }
          } else {
            listItem += styledText;
          }

          listItem += `</li>`;
          currentListItems.push(listItem);

          currentIndex = start + len;
          return;  
        } else {
          if (currentList) {
            result += `${currentListItems.join("")}</${currentList}>`;
            currentList = null;
            currentListItems = [];
          }
          result += styledText;
        }

        currentIndex = start + len;
      });

      if (currentList) {
        result += `${currentListItems.join("")}</${currentList}>`;
        currentList = null;
        currentListItems = [];
      }

      if (currentIndex < message.length) {
        const tailText = message.substring(currentIndex);
        if (tailText.trim() !== "") {
          if (!currentList) { 
            result += tailText;
          }
        }
      }
      // console.log(123, result);
      
      return result;
    }
  },
  methods: {
    normalizeText(text, afterList = false) {
    if (afterList) {
      // bỏ newline ở đầu đoạn sau list
      text = text.replace(/^\n+/, "");
    }
    return text.replace(/\n/g, "<br>");
  },
    IsJsonString() {
      try {
        var json = JSON.parse(this.content);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    checkAction() {
      let con = JSON.parse(this.content);
      if (["msginfo.actionlist", "rtf"].includes(con.action)) {
        return true;
      }
      return false;
    },
    isRtf() {
      let con = JSON.parse(this.content);
      if (con.action != null && con.action === "rtf") return true;
      return false;
    },
    isHightLight() {
      let con = JSON.parse(this.content);
      let params = JSON.parse(con.params);
      return params.highLightsV2 != null && params.highLightsV2.length > 0;
    },
    getUrl() {
      let con = JSON.parse(this.content);
      let params = JSON.parse(con.params);
      if (params.avatarUrl && params.avatarUrl.length > 0) {
        return params.avatarUrl[0];
      }
      return "";
    },
    replace(instr, name, start, length) {
      let text = instr.substr(0, start) + name + instr.substr(start + length);
      return text;
    },

    convertToMentions(message) {
      try {
        if (!Array.isArray(this.listMentions) || this.listMentions.length === 0) {
          return [message]; // giữ nguyên API cũ: trả về mảng để .join("")
        }

        // sort DESC để thay từ phải sang trái, tránh lệch offset các mention còn lại
        const mentions = [...this.listMentions].sort((a, b) => b.pos - a.pos);

        const parser = new DOMParser();
        // bọc message để DOMParser không drop node lẻ
        const doc = parser.parseFromString(`<div id="__root__">${message}</div>`, "text/html");
        const root = doc.getElementById("__root__");

        // Build a linear list of "text segments" mapping plain-text offsets to actual text nodes.
        // For text nodes: segment.text = node.nodeValue
        // For <br>: segment.text = "\n" (length = 1), node = the <br> element and mark isBr = true
        const segments = [];
        (function walk(node) {
          for (let child = node.firstChild; child; child = child.nextSibling) {
            if (child.nodeType === Node.TEXT_NODE) {
              const txt = child.nodeValue || "";
              if (txt.length > 0) {
                segments.push({ node: child, text: txt, isBr: false });
              }
            } else if (child.nodeType === Node.ELEMENT_NODE) {
              const tag = child.tagName.toLowerCase();
              if (tag === "br") {
                // represent br as a single '\n' character in the plain-text mapping
                segments.push({ node: child, text: "\n", isBr: true });
              } else {
                walk(child);
              }
            }
          }
        })(root);

        // Build prefix-sum start positions for quick mapping
        let acc = 0;
        for (const seg of segments) {
          seg.start = acc;
          seg.len = seg.text.length;
          acc += seg.len;
          seg.end = seg.start + seg.len; // exclusive
        }
        const totalPlainLen = acc;

        // helper: map absolute plain-text offset -> { node, offsetInNode }
        const findBoundary = (absOffset) => {
          if (absOffset <= 0) {
            // before everything: return start of first text node if exists
            const first = segments[0];
            if (first) {
              if (first.isBr) {
                // br as first => map to parent before br (use br.parentNode, child index of br)
                return { node: first.node.parentNode, offset: Array.prototype.indexOf.call(first.node.parentNode.childNodes, first.node) };
              } else {
                return { node: first.node, offset: 0 };
              }
            }
            return { node: root, offset: 0 };
          }
          if (absOffset >= totalPlainLen) {
            const last = segments[segments.length - 1];
            if (last) {
              if (last.isBr) {
                // map to after last br
                const parent = last.node.parentNode;
                const idx = Array.prototype.indexOf.call(parent.childNodes, last.node);
                return { node: parent, offset: idx + 1 };
              } else {
                return { node: last.node, offset: last.node.nodeValue.length };
              }
            }
            return { node: root, offset: root.childNodes.length };
          }

          // binary search or linear scan (segments typically small) -> linear is fine
          for (let i = 0; i < segments.length; i++) {
            const s = segments[i];
            if (absOffset >= s.start && absOffset <= s.end) {
              const inSeg = absOffset - s.start;
              if (!s.isBr) {
                // normal text node
                return { node: s.node, offset: inSeg };
              } else {
                // boundary falls on a <br> (we treat it as '\n'):
                // To create a valid Range, map to the position right before/after the <br>.
                // If inSeg === 0 => position at start of br -> we set to before br (parent, index of br)
                // if inSeg === 1 => position after br -> parent, index after br
                const parent = s.node.parentNode;
                const childIndex = Array.prototype.indexOf.call(parent.childNodes, s.node);
                if (inSeg === 0) {
                  return { node: parent, offset: childIndex };
                } else {
                  return { node: parent, offset: childIndex + 1 };
                }
              }
            }
          }

          // fallback
          const last = segments[segments.length - 1];
          return last && !last.isBr
            ? { node: last.node, offset: last.node.nodeValue.length }
            : { node: root, offset: root.childNodes.length };
        };

        mentions.forEach(m => {
          if (typeof m.pos !== "number" || typeof m.len !== "number" || m.len <= 0) return;

          // clamp positions to available plain-text length to avoid exceptions
          const startAbs = Math.max(0, Math.min(totalPlainLen, m.pos));
          const endAbs = Math.max(0, Math.min(totalPlainLen, m.pos + m.len));

          const startB = findBoundary(startAbs);
          const endB   = findBoundary(endAbs);
          if (!startB.node || !endB.node) return;

          const range = doc.createRange();
          try {
            range.setStart(startB.node, startB.offset);
            range.setEnd(endB.node, endB.offset);
          } catch (err) {
            // If for some reason the node/offset combination is invalid, skip this mention
            console.warn("Invalid range for mention", m, startB, endB, err);
            range.detach && range.detach();
            return;
          }

          // Lấy alias hiển thị
          let display = null;
          const aliases = this.app?.aliases;
          const accId  = this.app?.selectedConversation?.accountId;
          if (Array.isArray(aliases)) {
            const hit = aliases.find(s => s.accountId === accId && s.id === m.uid);
            if (hit) display = "@" + hit.name;
          }
          if (!display) {
            // fallback: giữ nguyên text mention gốc
            display = range.toString();
          }

          // Thay range bằng <span class="...">@name</span>
          const span = doc.createElement("span");
          span.className = "pointer mb-0 text-link";
          span.textContent = display;

          range.deleteContents();
          range.insertNode(span);
          range.detach && range.detach();
        });

        // trả về mảng 1 phần tử để .join("") như code hiện tại
        return [root.innerHTML];
      } catch (e) {
        console.error("convertToMentions failed:", e);
        return [message];
      }
    },
    regexUrl(message) {
      if (this.keyHighlight) {
        return this.contentAfterHighlight;
      }

      let arr = this.convertToMentions(message);
      // let urlRegex = /((https?:\/\/|www\.)[^\s<]+)/g;

      // Không escape toàn bộ HTML nữa, chỉ escape khi thực sự cần
      let safeMessage = arr.length > 0 ? arr.join("") : message;
      
      safeMessage = safeMessage.replace(/\n/g, "<br>");
      // escape whole invalid tags (stop at next '>' but don't allow inner '<' to be consumed)
      safeMessage = safeMessage.replace(/<(?!\/?(div|span|br|p|b|i|u|strong|em|ol|ul|li|a)\b)[^<>]*>/gi, (match) => {
        return match.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      });
      // escape any remaining '<' that do NOT start an allowed tag (e.g. "<67kg")
      safeMessage = safeMessage.replace(/<(?!\/?(div|span|br|p|b|i|u|strong|em|ol|ul|li|a)\b)/gi, "&lt;");

      const urlRegex = /\b((https?:\/\/|www\.)[^\s<>"']*[^\s<>"',.!?;:()[\]{}])/gi;

      return safeMessage.replace(urlRegex, (match) => {
        const href = match.startsWith("www.") ? `http://${match}` : match;
        return `<a class="color-blue" href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      });
    },
    handleLinkClick(event) {
      if (event.target.tagName === "A" && event.target.href.includes("zalo.me/g/")) {
        event.preventDefault();
        this.$emit("clickLinkGroup", event.target.href);
      }
    },
    regexUrlFromText(text) {
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');
    },
  },
  mounted() {
    if (this.mentions && this.mentions !== "") {
      this.listMentions = JSON.parse(this.mentions).sort((a, b) => a.pos - b.pos);
      if (typeof this.listMentions === "string") {
        this.listMentions = [];
      }
    }
  },
};
</script>

<style scoped>
</style>
